import React, { useState, useRef, useEffect } from "react";
import { Button, Grid, InputAdornment, MenuItem, Select, TextField, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector } from "react-redux";
import { service } from "../../model";
import "../../assets/css/icon.css";

const ALTRO = "other";

const ModalRichiediConferma = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  copyButton,
  amlId,
}) => {
  const token = useSelector((state) => state.user?.redux_object?.accessToken);

  const [assignmentTitle, setAssignmentTitle] = useState("");
  const [assignmentReason, setAssignmentReason] = useState("");
  const [titleSelectOpen, setTitleSelectOpen] = useState(false);
  const titleFromArrow = useRef(false);
  const [natureOptions, setNatureOptions] = useState([]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const data = await service.getNatureService(token, amlId);
        const opts = (data.nature?.options || []).map((opt) => ({
          label: opt.value === ALTRO ? "Altro" : opt.label,
          value: opt.value,
        }));
        const hasOther = opts.some((o) => o.value === ALTRO);
        if (data.nature_other && !hasOther) {
          opts.push({ label: "Altro", value: ALTRO });
        }
        setNatureOptions(opts);
      } catch (err) {
        console.error(err);
      }
    };
    if (amlId) fetchOptions();
  }, [amlId]);

  const handleConfirm = () => {
    const newErrors = [];
    if (!assignmentTitle) newErrors.push("assignmentTitle");
    if (assignmentTitle === ALTRO && !assignmentReason.trim()) newErrors.push("assignmentReason");
    if (newErrors.length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors([]);
    confirm(assignmentTitle, assignmentReason);
  };

  return (
    <Grid
      container
      item
      xs={11}
      md={7}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "90vh",
        overflowY: "auto",
        width: { xs: "95%", sm: "80%" },
        borderRadius: "16px",
        outline: "none",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* ── Header ── */}
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          padding: "0 15px",
          gap: "10px",
          flexShrink: 0,
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <div className="icon-generate-otp-modal" />
        </div>
        <Typography
          className="color-blue-dark"
          style={{ flex: 1, minWidth: 0, fontSize: "18px", fontWeight: 600 }}
        >
          {title}
        </Typography>
        <div style={{ flexShrink: 0 }}>
          <div onClick={onClose} className="icon-modal-close" />
        </div>
      </Grid>

      {/* ── Body ── */}
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 20px 30px",
        }}
      >
        {descriptionOne && (
          <Typography
            className="color-blue-dark"
            style={{ marginBottom: "20px", fontSize: "16px" }}
          >
            {descriptionOne}
          </Typography>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography className="color-blue-dark title-input">
              Natura e scopo della prestazione professionale
            </Typography>
            {assignmentTitle !== ALTRO ? (
              <Select
                value={assignmentTitle}
                error={errors.includes("assignmentTitle")}
                onChange={(e) => {
                  titleFromArrow.current = false;
                  const val = e.target.value;
                  setAssignmentTitle(val);
                  if (errors.length) setErrors([]);
                  if (val !== ALTRO) setAssignmentReason("");
                }}
                open={titleSelectOpen}
                onOpen={() => setTitleSelectOpen(true)}
                onClose={() => {
                  setTitleSelectOpen(false);
                  if (titleFromArrow.current && assignmentReason) setAssignmentTitle(ALTRO);
                  titleFromArrow.current = false;
                }}
                displayEmpty
                fullWidth
                sx={{ mt: 0.5 }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {natureOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <TextField
                value={assignmentReason}
                error={errors.includes("assignmentReason")}
                onChange={(e) => {
                  setAssignmentReason(e.target.value);
                  if (errors.length) setErrors([]);
                }}
                placeholder="Inserisci"
                fullWidth
                variant="outlined"
                inputProps={{ maxLength: 200 }}
                sx={{ mt: 0.5 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <ArrowDropDownIcon
                        style={{ cursor: "pointer", color: "rgba(0,0,0,0.54)" }}
                        onClick={() => {
                          titleFromArrow.current = true;
                          setAssignmentTitle("");
                          setTitleSelectOpen(true);
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      {/* ── Footer ── */}
      <Grid container item xs={12}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <Button
            className="button-bg-purple"
            sx={{ width: "140px" }}
            onClick={handleConfirm}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {copyButton ?? "Invia"}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalRichiediConferma;
